import React, { Component } from 'react'
import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';
import withExclusions from './withExclusions.js';
const type = 'tradingRestrictions'
export class TradingRestrictions extends Component {
    render() {
        const {underStyle, confirmed, modifiedFields, getError, renderExcl, choose, change, dataSource, currentExcl} = this.props;
        return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexWrap: 'wrap',}}>
                    {renderExcl(type)}
                </div>
                <AutoComplete
                    name={type}
                    disabled={confirmed}
                    dataSource={dataSource}
                    dataSourceConfig={{ text: 'name', value: 'tradingRestriction' }}
                    floatingLabelText='Trading Restrictions'
                    onUpdateInput={change}
                    searchText={currentExcl.name || ''}
                    onNewRequest={excl => choose(type, excl)}
                    filter={AutoComplete.noFilter}
                    errorText={getError('tradingRestrictions')}
                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    fullWidth
                    underlineStyle={modifiedFields && modifiedFields.includes('tradingRestrictions') ? underStyle : null}
                />
            </div>
        )
    }
}

export default withExclusions(name => api.findPortAdmin({name}), TradingRestrictions);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TradingRestrictions.jsx